import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';

/**
 * Client-side boundary for the admin sections a `support` user may not enter.
 *
 * Support shares the /admin route tree and the AdminLayout so that Customers,
 * Employees and Assignments stay one implementation rather than two, which
 * means every OTHER admin page has to be closed off explicitly. Used as a
 * pathless layout route wrapping those pages, so a page added inside it is
 * closed by default — the same fail-closed shape as the admin-only barrier in
 * backend/routes/admin.js.
 *
 * The API enforces this too (a support token gets 403 on those routes); this
 * guard stops the page mounting and firing its fetches at all, including via a
 * pasted URL.
 */
const AdminOnlyRoute = () => {
  const { currentUser } = useAuth();

  if (currentUser?.userType !== 'admin') {
    return <Navigate to="/admin/customers" replace />;
  }

  return <Outlet />;
};

export default AdminOnlyRoute;
